import { ListChecks, ChatCircleDots, Package, Paperclip, Camera, Signature, Sparkle } from "@phosphor-icons/react";

const TABS = [
  { k: "overview", label: "Vue d'ensemble", icon: ListChecks },
  { k: "documents", label: "Documents", icon: Paperclip },
  { k: "chat", label: "Chat", icon: ChatCircleDots },
  { k: "material", label: "Matériel", icon: Package },
  { k: "panel", label: "Tableau IA", icon: Sparkle },
  { k: "photos", label: "Photos", icon: Camera },
  { k: "signatures", label: "Signatures", icon: Signature },
];

export default function ChantierTabs({ tab, onChange }) {
  return (
    <div className="flex gap-1 bg-white/5 border border-white/10 rounded-full p-1 overflow-x-auto no-scrollbar" data-testid="detail-tabs">
      {TABS.map((t) => (
        <button
          key={t.k}
          onClick={() => onChange(t.k)}
          data-testid={`chantier-tab-${t.k}`}
          className={`flex items-center gap-1.5 shrink-0 text-xs px-3 py-1.5 rounded-full ${tab === t.k ? "bg-[#005CFF] text-white" : "text-white/60"}`}
        >
          <t.icon size={14} weight="bold" /> {t.label}
        </button>
      ))}
    </div>
  );
}
